"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnifiedSkeleton = exports.MobileOfficeRoot = void 0;
var _mui = require("@ori-ui/mui");
var _personalMenu = require("@ori/personal-menu");
var _presentationUtils = require("@ori/presentation-utils");
/* istanbul ignore file */

const UnifiedSkeleton = exports.UnifiedSkeleton = (0, _mui.styled)(_mui.Skeleton)({
  transform: 'none'
});
const MobileOfficeRoot = exports.MobileOfficeRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isMobileOffice,
  isMobileOfficeFull,
  theme
}) => {
  if (isMobileOfficeFull) {
    return {
      [theme.breakpoints.up(_personalMenu.BREAKPOINT_HORIZONTAL_SIDEPANEL_LEGACY)]: {
        // Since there is a left menu, we have to set this style to make footer elements centered within the right container area.
        borderLeft: '280px solid transparent'
      },
      [theme.breakpoints.up(1604)]: {
        borderLeft: 'none'
      }
    };
  }
  if (isMobileOffice) {
    return {
      [theme.breakpoints.up(_personalMenu.BREAKPOINT_HORIZONTAL_SIDEPANEL_LEGACY)]: {
        borderLeft: '280px solid transparent'
      },
      [theme.breakpoints.up(1604)]: {
        borderLeft: 'none'
      }
    };
  }
  return {};
});